import { render } from "./ProductShowcase.vue?vue&type=template&id=f8f9766e&scoped=true"
import script from "./ProductShowcase.vue?vue&type=script&lang=js"
export * from "./ProductShowcase.vue?vue&type=script&lang=js"

import "./ProductShowcase.vue?vue&type=style&index=0&id=f8f9766e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8f9766e"]])

export default __exports__